import { Box, Button, Callout, Checkbox, Flex, Separator, Text, TextField } from '@radix-ui/themes'
import React, { useState } from 'react'
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { permissions } from '../../config/permissions';
import './login.css';
import LoginForm from '../../components/ui-components/LoginForm';
import loginLogo from '../../assets/Luka-Healthcare.png';
import signImage from '../../assets/sign-image.svg';
import logoIMCAS from '../../assets/imacs_logo.svg';
import googlePlay from '../../assets/Google-Play.svg';
import appleStore from '../../assets/Apple-Store.svg';
import { FaInfoCircle } from 'react-icons/fa';
import ForgotPassword from '../../components/ui-components/ForgotPassword';

const Login = () => {
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    if (showForgotPassword) {
        return <ForgotPassword onBack={() => setShowForgotPassword(false)} />;
    }

    return (
        <Flex direction={'row'} className='min-h-screen w-screen'>
            {/* Left decorative panel — hidden on mobile, visible on lg+ */}
            <Box className='hidden lg:flex h-screen bg-[#ecf2f1] w-[41.5%] sticky top-0'>
                <Flex gap={'6'} direction={'column'} align={'center'} className='h-full w-full'>
                    <img  className='w-[70%] my-24' src={loginLogo} alt="" />
                    <img className='w-[88%] mt-0' src={signImage} alt="" />
                </Flex>
            </Box>
            {/* Right form panel — full width on mobile, constrained on lg+ */}
            <Box className='w-full lg:w-[59.5%]'>
                <Flex direction={'column'} align={'center'} justify={'center'} className='min-h-screen py-10'>
                    <div className="w-full max-w-[450px] px-6">
                        <div className="flex flex-col my-4">
                            <img width={'300px'} className='mt-8 lg:mt-16 mb-2' src={logoIMCAS} alt="" />
                            <Text size="8">Log in</Text>
                            <Text size="2">Enter your details to Login to your account</Text>
                        </div>
                        
                        <LoginForm onForgotPassword={() => setShowForgotPassword(true)} />

                        <div className="mt-12 w-full">
                            <Separator size="4" className="opacity-10 mb-4" />
                            <Flex direction="row" align="center" justify="center" gap="5" className="text-gray-400 text-xs flex-wrap font-semibold">
                                <a 
                                    href="https://www.lukahealthcare.com/" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="hover:text-teal-600 transition-colors duration-200"
                                >
                                    About Us
                                </a>
                                <span className="opacity-30">•</span>
                                <Link 
                                    to="/terms" 
                                    className="hover:text-teal-600 transition-colors duration-200"
                                >
                                    Terms of Service
                                </Link>
                                <span className="opacity-30">•</span>
                                <a 
                                    href="https://www.lukahealthcare.com/contact/" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="hover:text-teal-600 transition-colors duration-200"
                                >
                                    Contact
                                </a>
                            </Flex>
                        </div>
                    </div>
                </Flex>
            </Box>
        </Flex>
    )
}

export default Login
